/**
 * @class Menu
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const content = $('.l-content');
const ACTIVE_CLASS = 'active';

export class Menu {
    headerEl = '.l-header';
    menu = '.js-header-menu';
    hMenuEl = '.js-header-m';
    burgerEl = '.js-header-burger';
    item = '.js-header-menu-item';
    link = '.js-header-menu-link';
    dropdown = '.js-header-menu-submenu';
    overlayEl = '.js-overlay';
    overlayMobileEl = '.js-overlay-mobile';
    animate = '.js-animate';
    closeSubMenuEl = '.js-header-menu-close-submenu';
    closeMenuEl = '.js-close-menu';
    mouseEnterTimer;
    mouseLeaveTimer;
    headerHeight = 0;
    isOpen = false;

    mobileQuery = window.matchMedia('(max-width: 1199px)');

    timer;

    isMobile = () => {
        return this.mobileQuery.matches;
    }

    overlayClick = () => {
        this.isOpen = false;
        this.menuClose();
        this.overlay.fadeOut();

        if (this.isMobile()){
            this.onMobileMenuClose();
        }
    }

    menuClose = () => {
        // const dropdown = $(this.menu).find(this.dropdown);
        const animations = $(this.menu).find(this.animate);

        animations.each((index, item) => {
            $(item).removeClass('js-animate-loaded');
        });

        this.items.each((index, item) => {
            $(item).parent().removeClass(ACTIVE_CLASS);
        });

        this.dropdowns.each((index, item) => {
            $(item).removeClass(ACTIVE_CLASS);
            setTimeout(() => {
                this.header.removeClass(ACTIVE_CLASS);
                $(item).css({'top': '', 'display': ''});
            }, 600);
        });
        $('body').css({overflow: ''});
        this.isOpen = false;
    }

    menuOpen = (e) => {
        const dropdown = $(e.currentTarget).parent().find('.js-header-menu-submenu');
        const animations = this.header.find(this.animate);

        // @todo disable this on mobile
        if (dropdown.length && !this.isOpen){
            if (!this.isMobile()){
                $(this.overlay).fadeIn();
                $('body').css({overflow: 'hidden'});
            }
        }

        if (this.isOpen){
            this.menuClose();
            this.timer = setTimeout(() => {
                dropdown.css({top: this.headerHeight}).show(0).addClass(ACTIVE_CLASS);
                animations.each((index, item) => {
                    this.header.addClass(ACTIVE_CLASS);
                    $(item).addClass('js-animate-loaded');
                });
            }, 600);
            $('body').css({overflow: ''});
        }else {
            dropdown.css({top: this.headerHeight}).show(0).addClass(ACTIVE_CLASS);
            animations.each((index, item) => {
                $(item).addClass('js-animate-loaded');
            });
            this.header.addClass(ACTIVE_CLASS);
        }

        $(e.currentTarget).parent().addClass(ACTIVE_CLASS);

        this.isOpen = true;
    }

    onItemClick = (e) => {
        if ($(e.currentTarget).parent().find('.js-header-menu-submenu').length) {
            e.preventDefault();
        }

        clearTimeout(this.timer);
        this.headerHeight = this.header.height();
        let isCurrentOpen = $(e.currentTarget).parent().hasClass('active');

        if (isCurrentOpen){
            return;
        }

        this.menuOpen(e);
    }

    onOverlayClick = (e) => {
        this.overlayClick();
    }

    onEscPress = (e) => {
        if (e.keyCode === 27) this.overlayClick();
    }

    onMobileMenuOpen = () => {
        this.hMenu.show(0, function() {
            $('.b-menu').animate({'right': '0'}, 300);
        });

        if (this.isMobile()){
            $(this.overlayMobile).fadeIn();
        }else{
            $(this.overlay).fadeIn();
        }
        this.isOpen = true;
    }

    onMobileMenuClose = () => {
        $('.b-menu').animate({'right': '-100%'}, 300, () => {
            this.hMenu.hide();
        });
        $(this.overlay).fadeOut();

        this.isOpen = false;
    }

    showOnDesktop = () => {
        if (!this.isMobile()){
            this.hMenu.show(0);
        }
    }

    constructor(node) {
        this.node = $(node);
        this.items = this.node.find(this.link);
        this.dropdowns = this.node.find(this.dropdown);
        this.overlay = $(this.overlayEl);
        this.overlayMobile = $(this.overlayMobileEl);
        this.closeSubMenu = $(this.closeSubMenuEl);
        this.closeMenu = $(this.closeMenuEl);
        this.hMenu = $(this.hMenuEl);
        this.burger = $(this.burgerEl);
        this.header = $(this.headerEl);

        this.items.each((index, item) => {
            $(item).click(this.onItemClick);
        });

        this.closeMenu.on('click', this.onOverlayClick);
        this.overlayMobile.on('click', this.onOverlayClick);
        this.overlay.on('click', this.onOverlayClick);
        this.closeSubMenu.on('click', this.menuClose);
        this.burger.on('click', this.onMobileMenuOpen);
        $(document).on('keyup', this.onEscPress);
        $(window).on('resize', this.showOnDesktop);
    }
}



// WEBPACK FOOTER //
// ./app/scripts/shared/Menu.js